import React from 'react';

const NotificationBadge = ({ count = 0, maxDisplay = 99, className = '' }) => {
  if (count <= 0) return null;

  const displayCount = count > maxDisplay ? `${maxDisplay}+` : count;

  return (
    <span
      className={`absolute -top-1 -right-1 flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-medium font-caption bg-error text-error-foreground rounded-full transition-smooth ${className}`}
      aria-label={`${count} notificações não lidas`}
    >
      {displayCount}
    </span>
  );
};

export default NotificationBadge;